import {Segment} from 'semantic-ui-react';

function ContactUs() {
  return (
    <Segment>
      <h1>ارتباط با ما</h1>
      <div>
        <span>آدرس کانال تلگرام:</span>&nbsp;
        <a href='https://t.me/medmoshaver'>https://t.me/medmoshaver</a>
      </div>
      <div>
        <span>آدرس اینستاگرام:</span>&nbsp;
        <a href='https://instagram.com/medmoshaver'>https://instagram.com/medmoshaver</a>
      </div>
      <div> آدرس پستی: تهران، نارمک، خیابان بزرگیان، کوچه شهید حسینی، پلاک 7 واحد 15</div>
      <div> شماره تلفن ثابت: 02177030597</div>

    </Segment>
  );
}

export default ContactUs;
